import {
  Scene, Mesh, SphereGeometry, MeshPhongMaterial,
  Vector3, Group, Object3D,
} from 'three';

const BULLET_SPEED    = 900;   // units/s
const BULLET_LIFETIME = 2.5;   // 秒
const BULLET_RADIUS   = 0.35;
const HIT_RADIUS      = 8;     // プレイヤーへの当たり判定半径

const matTracer = new MeshPhongMaterial({
  color: 0xffaa00,
  emissive: 0xff6600,
  emissiveIntensity: 2.0,
  shininess: 60,
});

interface Bullet {
  mesh: Mesh;
  velocity: Vector3;
  life: number;
}

/**
 * 敵機・砲台が発射するトレーサー弾丸システム
 * 明るいオレンジ色の光弾として視認できる
 */
export class EnemyBulletSystem {
  private scene: Scene;
  private bullets: Bullet[] = [];
  private geo = new SphereGeometry(BULLET_RADIUS, 5, 5);

  constructor(scene: Scene) {
    this.scene = scene;
  }

  /** 弾丸を生成して追加 */
  fire(from: Vector3, dir: Vector3): void {
    const mesh = new Mesh(this.geo, matTracer);
    mesh.position.copy(from);

    const velocity = dir.clone().normalize().multiplyScalar(BULLET_SPEED);

    this.scene.add(mesh);
    this.bullets.push({ mesh, velocity, life: BULLET_LIFETIME });
  }

  /**
   * フレーム更新
   * @returns プレイヤーへの合計ダメージ（ヒット数 × ダメージ量）
   */
  update(delta: number, playerPos: Vector3): number {
    let damage = 0;
    const toRemove: Bullet[] = [];

    for (const b of this.bullets) {
      b.life -= delta;
      if (b.life <= 0) {
        toRemove.push(b);
        continue;
      }

      b.mesh.position.addScaledVector(b.velocity, delta);

      // プレイヤーとの当たり判定
      if (b.mesh.position.distanceTo(playerPos) < HIT_RADIUS) {
        damage += 8;
        toRemove.push(b);
      }

      // 地面衝突
      if (b.mesh.position.y <= 0) {
        toRemove.push(b);
      }
    }

    for (const b of toRemove) {
      this.scene.remove(b.mesh);
      const idx = this.bullets.indexOf(b);
      if (idx !== -1) this.bullets.splice(idx, 1);
    }

    return damage;
  }

  dispose(): void {
    for (const b of this.bullets) {
      this.scene.remove(b.mesh);
    }
    this.bullets = [];
    this.geo.dispose();
  }
}
